import { Location } from '@/rest/__generated/revspringApi';
import { TAGBrand } from '@/types';

export interface IOnPageSchedulingDetails {
	coords?: {
		latitude?: number;
		longitude?: number;
	};
	brand: TAGBrand;
	onPageScheduling: boolean;
}
/*
 * Get the scheduling system for the facility based on the brand and coordinates. (for WellNow brands )
 * @param {IOnPageSchedulingDetails} params - The parameters for getting the scheduling system.
 * @returns {Promise<string | null>} - The scheduling system or null if not found.
 */
export async function getOnPageSchedulingDetails({ coords, brand, onPageScheduling }: IOnPageSchedulingDetails) {
	if (!onPageScheduling) {
		return null;
	}

	if (!coords?.latitude || !coords?.longitude) {
		return null;
	}

	if (brand === TAGBrand.WellNow || brand === TAGBrand.YouWellNow || brand === TAGBrand.LivWellNow) {
		try {
			const { default: getLocationDetails } = await import('./getLocationDetails');

			const { schedulingSystem }: Location = await getLocationDetails({
				latitude: coords.latitude,
				longitude: coords.longitude,
			});
			if (schedulingSystem) {
				return schedulingSystem;
			}
		} catch (error) {
			console.error('Error getting scheduling system', error);
			return null;
		}
		return 'Unknown';
	}
	// For AspenDental and other brands, this remains to be implemented, for now, we are returning InHouse
	return 'InHouse';
}
